/**
 *
 * External links
 *
 * Change page links to open in the same tab
 * if they are considered to be external.
 *
 */
(function ($) {
  //////////
  //
  // Globals
  //

  const documentHost = document.location.host;
  const allowedExternalHosts = [
    "public.govdelivery.com",
    "myplate-prod.azureedge.us",
  ];

  //////////
  //
  // Functions
  //

  /**
   * Is this an external host?
   * @param {string} host
   * @returns {boolean}
   */
  function isExternalHost(host) {
    // The link is external if:
    return (
      host &&
      host !== documentHost && // 1. not current host
      !/\.gov$/.test(host) && // 2. not ending with .gov
      $.inArray(host, allowedExternalHosts) === -1 // 3. not on our inclusion list
    );
  }

  /**
   * Make first word nowrap with icon
   * @param {jQuery} $el
   * @returns {void}
   */
  function noWrapFirstWord($el) {
    let node = $el
        .contents()
        .filter(function () {
          return this.nodeType === 3;
        })
        .first(),
      text = node.text(),
      firstWord = text.split(" ", 1).join(" ");
    if (!node.length) {
      return;
    }

    node[0].nodeValue = text.slice(firstWord.length);
    node.before(
      `<span class="whitespace-nowrap"><span class="icon icon-new-tab external-link"></span>${firstWord}</span>`
    );
  }

  //////////
  //
  // Attach Drupal behavior
  //
  Drupal.behaviors.myplate_external_links = {
    attach: function (context, settings) {
      if ($(".mp-container a", context).length) {

      }

      $(once('mp-external-links', ".mp-container a", context))
        .not(':has(div,img), .usa-link-no-external-link-icon')
        // .once("mp-external-links")
        .each((i, el) => {
          const host = el.host,
            $a = $(el);

          // Remove all pre-existing `target="_blank"` attributes
          if (
            window.self === window.top && // Do not remove for iframe
            $a.attr("target") &&
            $a.attr("target").toLowerCase() === "_blank"
          ) {
            $a.removeAttr("target");
          }

          if (isExternalHost(host)) {
            noWrapFirstWord($a);
          }
        });

    },
  };
})(jQuery);
